import { createStore } from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import canteen from './modules/canteen'
import feedback from './modules/feedback'
import app from './modules/app'

export default createStore({
  modules: {
    auth,
    user,
    canteen,
    feedback,
    app
  },
  strict: process.env.NODE_ENV !== 'production'
})
